"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const error_1 = require("./error");
const store_1 = require("./store");
const useDebugValue = (_a = React.useDebugValue) !== null && _a !== void 0 ? _a : (() => { });
function Consumer(props) {
    const store = useStore(props.of);
    return props.children(store);
}
exports.Consumer = Consumer;
function useStore(s, deps) {
    const name = s.displayName || s.name;
    useDebugValue(name);
    const Context = store_1.getStoreContext(s);
    const container = react_1.useContext(Context);
    const [state, setState] = react_1.useState(container.state);
    const depsRef = react_1.useRef([]);
    react_1.useEffect(() => {
        const subscriber = () => {
            if (!deps) {
                setState(container.state);
            }
            else {
                const oldDeps = depsRef.current;
                const newDeps = deps(container.state);
                if (compare(oldDeps, newDeps)) {
                    setState(container.state);
                }
                depsRef.current = newDeps;
            }
        };
        container.subscribers.add(subscriber);
        return () => {
            container.subscribers.delete(subscriber);
        };
    }, []);
    if (state === store_1.defaultStoreValue) {
        throw new error_1.NoStoreError(`No store context of "${name}" found. And "${name}" doesn't have defaultValue. Either render a Provider or set a defaultValue for this Store.`, s);
    }
    return state;
}
exports.useStore = useStore;
function useStoreOptionally(s, deps) {
    try {
        const store = useStore(s, deps);
        return [store, true];
    }
    catch (e) {
        if (e instanceof error_1.NoStoreError) {
            return [undefined, false];
        }
        else {
            throw e;
        }
    }
}
exports.useStoreOptionally = useStoreOptionally;
function compare(oldDeps, newDeps) {
    if (oldDeps.length !== newDeps.length) {
        return true;
    }
    for (const index in newDeps) {
        if (oldDeps[index] !== newDeps[index]) {
            return true;
        }
    }
    return false;
}
